<div class="pageheader">
  <div class="page-title">
    <h1>Document Type Classifier Resolvers</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Document Type Classifier Resolvers log'">
        <app-change-log-link-entity type="DocumentTypeClassifierResolver"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="xcontainer xcontainer-fixed">
  <div class="xrow">
    <div class="col-sm-12">
      <dx-data-grid #duplicateCheckGrid
        biz-grid
        [selection]='{ mode: "none" }'
        [dataSource]='documentTypeClassifierResolver'
        [bizHideSelectedRowsComponent]="true"
        [showResetButton]="true"
        (onEditingStart)="onEditingStart($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowInserting)="onRowInserting($event)"
        (onRowUpdating)="onRowUpdating($event)"
        (onRowRemoving)="onRowRemoving($event)"
        [bizEditRowOnDoubleClick]="true">

        <dxo-editing mode="popup"
          [allowAdding]="hasCreatePerm"
          [allowUpdating]="hasEditPerm"
          [allowDeleting]="hasDeletePerm">
        </dxo-editing>

        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

        <dxi-column dataField="Name" caption="Name" dataType="string" [allowGrouping]="false" sortOrder="asc"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
        <dxi-column dataField="ContentTypeGroupId" caption="Content Type Group" dataType="string" cellTemplate="contentTypeGroupViewer" editCellTemplate="contentTypeGroupEditor"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
        <dxi-column dataField="ArtifactId" caption="Artifact" dataType="string" editCellTemplate="artifactEditTemplate" [customizeText]="displayExprArtifact" ><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>

        <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypeClassifierResolver, 'CreatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypeClassifierResolver, 'UpdatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

        <dxi-column type="buttons">
          <dxi-button name="edit"></dxi-button>
          <dxi-button name="delete"></dxi-button>
          <dxi-button text="Show Log"
            template="logTemplate"
            [visible]="hasShowLogPerm">
          </dxi-button>
        </dxi-column>

        <ng-container *dxTemplate="let cell of 'logTemplate'">
          <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="DocumentTypeClassifierResolver" [id]="cell.data.Id"></app-change-log-link-entity>
          </app-change-log-link>
        </ng-container>

        <div *dxTemplate="let cellInfo of 'contentTypeGroupViewer'">
          <span>{{getContentTypeGroupName(cellInfo.data)}}</span>
        </div>

        <div *dxTemplate="let cellInfo of 'contentTypeGroupEditor'">
          <select class="form-control" [ngModel]="selectedContentTypeGroup" (ngModelChange)="onGenericIdChanged($event, cellInfo)">
            <option [ngValue]="null">Select...</option>
            @for (item of contentTypeGroups; track item) {
              <option
                [ngValue]="item.Id"
                [title]="getContentTypeName(item)">
                {{item.Name}}
              </option>
            }
          </select>
        </div>

        <ng-container *dxTemplate="let cellInfo of 'artifactEditTemplate'">
          <app-developer-artifact-assembly-picker  [assemblyTypes]="['DocumentTypeClassiferResolver', 'DocumentTypeClassiferResolver2']" (selectedArtifactIdChange)="onArtifactChanged($event, cellInfo)" [selectedArtifactId]="cellInfo.data.ArtifactId"></app-developer-artifact-assembly-picker>
        </ng-container>
      </dx-data-grid>
    </div>
  </div>
</div>
